<template>
  <header class="SheetHeader">
    <button
      class="SheetHeader__button--cancel SheetHeader__button"
      type="button"
      @click="$emit('cancel')"
    >
      {{ cancelLabel }}
    </button>

    <h1 class="SheetHeader__title">
      {{ title }}
    </h1>

    <button
      v-if="!excludeSubmitButton"
      class="SheetHeader__button--save SheetHeader__button"
      type="submit"
      :disabled="isSubmitDisabled"
    >
      {{ submitLabel }}
    </button>
  </header>
</template>

<script lang="ts" setup>
defineEmits<{
  cancel: [],
}>();

const {
  cancelLabel = "Cancel",
  submitLabel = "Save",
} = defineProps<{
  title: string,
  excludeSubmitButton?: boolean,
  cancelLabel?: string,
  submitLabel?: string,
  isSubmitDisabled?: boolean,
}>();
</script>

<style lang="scss" scoped>
.SheetHeader {
  display: grid;
  grid: auto / repeat(3, 1fr);
  grid-auto-flow: column;
  align-items: center;
  padding: 24px 16px calc(24px - var(--fontSafariOffset));

  border-radius: 16px 16px 0 0;
  background-color: var(--themeColorSecondary);
  color: var(--themeColorSecondaryForeground);

  font-stretch: var(--fontWidthExtended);

  transition: 350ms background-color;
}

.SheetHeader__button {
  margin: -16px;
  padding: 16px;

  color: inherit;

  transition: 350ms opacity;

  &:disabled {
    opacity: 0.5;
  }
}

.SheetHeader__button--cancel {
  justify-self: start;
}

.SheetHeader__title {
  font-weight: var(--fontWeightMedium);
  text-align: center;
  white-space: nowrap;

  transition: 350ms color;
}

.SheetHeader__button--save {
  justify-self: end;
  font-weight: var(--fontWeightMedium);
}
</style>
